import { ReactNode } from "react";
import Navbar from "src/components/Layout/navbar";
import { Tooltip } from "react-tooltip";

type Props = {
  children?: ReactNode;
  title?: string;
  isLoading?: boolean;
  showNotification?: boolean;
  orderId?: string;
  renderBeforeLoad?: boolean;
  showNavbar?: boolean; // New optional prop to control navbar visibility
};

const Layout = ({
  children,
  isLoading = false,
  showNotification = false,
  orderId = "",
  renderBeforeLoad = true,
  showNavbar = true,  // Default to true, so navbar is shown unless specified otherwise
}: Props) => (
  <div className="h-screen overflow-hidden" style={{ backgroundColor: 'var(--bg-base)' }}>
    {isLoading && (
      <div className="w-screen h-screen text-center fixed z-50 pt-80">
        <svg
          className="animate-spin mt-20 h-8 w-8 inline-block rounded-full bg-transparent border-2 border-transparent border-opacity-50"
          viewBox="0 0 64 64"
          fill="none"
          style={{ borderRightColor: 'var(--color-primary)', borderTopColor: 'var(--color-primary)' }}
        ></svg>
      </div>
    )}
    {/* {showNotification && <NotificationAlert orderId={orderId} />} */}
    {showNavbar && <Navbar />} {/* Conditionally render Navbar based on showNavbar prop */}
    <div className={`${showNavbar ? "pt-16" : ""}`}>
      {/* Adjust padding-top to match navbar height only if navbar is shown */}
      {(renderBeforeLoad || !isLoading) && children}
      <Tooltip id="tooltip" place="bottom" style={{ zIndex: 100 }} />
    </div>
  </div>
);

export default Layout;
